import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'propertyStyle',
  standalone: true,
})
export class PropertyStylePipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }
}
